export default {
  request: function(req, tokens) {
    if (typeof tokens !== "undefined") {
      let tokensArray = tokens.split("||");
      this.drivers.http.setHeaders.call(this, req, {
        Authorization: "Bearer " + tokensArray[0]
      });
    }
  },
  response: function(res) {
    if (res.data) {
      // return token and refresh token
      if (res.data.access_token && res.data.refresh_token) {
        
        // clear redirect session storage
        sessionStorage.removeItem("_redirect_path");
        
        // manage impersonation user
        if (res.data.impersonate) {
          localStorage.setItem("_impersonate", true);
        } else {
          localStorage.removeItem("_impersonate");
        }

        const tokens = res.data;
        return `${tokens.access_token}||${tokens.refresh_token}`;
      }
    }
  }
};
